import React, {Component} from 'react';
import {connect} from 'react-redux';
import Action from 'actions';

class CorrelationStackingAllPlayersSwitcher extends Component {
    onCheck(isChecked) {
        const {players} = this.props;
        const list = {};
        players.map((player) => (list[player.getId()] = isChecked));
        this.props.dispatch(Action.set('UsageOfPlayersOnlyInCorrelationStacking', list));
    }

    areAllChecked() {
        const {csPlayers, players} = this.props;

        for (let player of players) {
            if (!csPlayers.isOnlyInCorrelationStackingUsed(player.getId())) {
                return false;
            }
        }

        return true;
    }

    render() {
        const {className = ''} = this.props;
        const isChecked = this.areAllChecked();

        return (
            <button
                className={isChecked ? `${className} active` : className}
                onClick={() => ::this.onCheck(!isChecked)}
                title={isChecked ? 'Chain to Stacking enabled' : 'Chain to Stacking disabled'}
            >
                {isChecked ? 'Chain to Stacking enabled' : 'Chain to Stacking disabled'}
            </button>
        );
    }
}

function mapStatesToProps(state) {
    const {correlationStacking} = state;

    return {
        csPlayers: correlationStacking.players,
    };
}

export default connect(mapStatesToProps)(CorrelationStackingAllPlayersSwitcher);
